import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../utils/theme-context';

const OwlTalkBox = ({ text, animate = true }) => {
  const { theme } = useTheme();
  return (
    <motion.div
      className="rounded-2xl px-6 py-4 max-w-xs sm:max-w-md md:max-w-lg mx-auto mb-4 relative bg-gradient-to-r from-blue-100 to-purple-100 dark:from-blue-900 dark:to-purple-900 border-2 border-blue-200 dark:border-blue-700 shadow-lg"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={animate ? { scale: 1, opacity: 1 } : {}}
      transition={{ type: 'spring', stiffness: 300 }}
      style={{
        fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
        padding: 'clamp(0.5rem, 2vw, 1.5rem)',
      }}
    >
      <span className="block font-semibold break-words text-blue-800 dark:text-blue-200" style={{ wordBreak: 'break-word', fontFamily: theme.fontFamily }}>{text}</span>
      <span className="absolute left-8 -bottom-4 w-6 h-6 rotate-45 rounded-sm bg-gradient-to-r from-blue-100 to-purple-100 dark:from-blue-900 dark:to-purple-900 border-r-2 border-b-2 border-blue-200 dark:border-blue-700"></span>
    </motion.div>
  );
};

export default OwlTalkBox; 